import { cn } from '@/lib/utils';
import type { ComponentProps } from 'react';

/**
 * Table chrome from the prototype: a sideline-tinted head, hairline row dividers, and a
 * hover tint. `text-start` rather than the prototype's `text-right` so the same table
 * reads correctly when `en` is switched on (ADR-013).
 */
export function Table({ className, ...props }: ComponentProps<'table'>) {
  return (
    <table
      data-slot="table"
      className={cn('w-full text-start text-[13px]', className)}
      {...props}
    />
  );
}

export function TableHeader({ className, ...props }: ComponentProps<'thead'>) {
  return (
    <thead
      data-slot="table-header"
      className={cn('bg-sideline text-[12px] font-bold text-conc-500', className)}
      {...props}
    />
  );
}

export function TableBody({ className, ...props }: ComponentProps<'tbody'>) {
  return (
    <tbody data-slot="table-body" className={cn('divide-y divide-conc-50', className)} {...props} />
  );
}

export function TableRow({ className, ...props }: ComponentProps<'tr'>) {
  return (
    <tr
      data-slot="table-row"
      className={cn('transition hover:bg-sideline', className)}
      {...props}
    />
  );
}

export function TableHead({ className, ...props }: ComponentProps<'th'>) {
  return (
    <th
      data-slot="table-head"
      scope="col"
      className={cn('px-4 py-3 text-start font-bold first:ps-5 last:pe-5', className)}
      {...props}
    />
  );
}

export function TableCell({ className, ...props }: ComponentProps<'td'>) {
  return (
    <td
      data-slot="table-cell"
      className={cn('px-4 py-3.5 align-middle first:ps-5 last:pe-5', className)}
      {...props}
    />
  );
}
